"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var lodash_1 = require("lodash");
var React = require("react");
var Marker_1 = require("./Marker");
var Edge = (function (_super) {
    __extends(Edge, _super);
    function Edge(props) {
        return _super.call(this, props) || this;
    }
    Edge.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, drawAs = _a.drawAs, color = _a.color, strokeDasharray = _a.strokeDasharray, borderWidth = _a.borderWidth, edgeDrawers = _a.edgeDrawers, points = _a.points, type = _a.type;
        var _b = edgeDrawers[drawAs], getPathSegments = _b.getPathSegments, getPointAtPosition = _b.getPointAtPosition;
        var pathSegments = getPathSegments(points, id);
        var d = pathSegments
            .map(function (pathSegment) {
            return pathSegment.command + pathSegment.points.join(',');
        })
            .join('');
        var markerProperties = lodash_1.intersection(Marker_1.MARKER_PROPERTY_NAMES, lodash_1.keys(this.props))
            .reduce(function (acc, markerLocationType) {
            var markerName = _this.props[markerLocationType];
            if (markerName) {
                acc.push({
                    name: markerLocationType,
                    // Currently just using the same color for backgroundColor (arrow head) as color (line)
                    // See line 86 in Kaavio.tsx
                    value: Marker_1.getMarkerPropertyValue(markerLocationType, markerName, color, color)
                });
            }
            return acc;
        }, []);
        var opts = {
            className: type,
            d: d,
            fill: 'transparent',
            stroke: color,
            strokeDasharray: strokeDasharray,
            strokeWidth: borderWidth,
            id: id,
        };
        markerProperties.filter(function (attribute) {
            // Ensure only markerEnd, markerStart or markerMid
            var allowed = ['markerMid', 'markerStart', 'markerEnd'];
            return allowed.indexOf(attribute.name) > -1;
        }).forEach(function (attribute) {
            opts[attribute.name] = attribute.value;
        });
        return React.createElement("path", __assign({ key: "path-for-" + id }, opts));
    };
    return Edge;
}(React.Component));
exports.Edge = Edge;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/Kaavio/components/Edge.js
// module id = 469
// module chunks = 0